import { Skeleton } from "antd";
import type { SkeletonProps } from "antd";
import { CSSProperties } from "react";

export type UISkeletonProps = SkeletonProps & {
  width?: number | string;
  height?: number | string;
  sx?: Record<string, unknown>;
};

export const UISkeleton = ({
  width,
  height,
  sx,
  style,
  ...props
}: UISkeletonProps) => (
  <Skeleton
    active
    title={false}
    paragraph={{ rows: 1, width: "100%" }}
    style={{
      width,
      height,
      ...(sx as CSSProperties),
      ...style,
    }}
    {...props}
  />
);
